/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var O;!function(O){O[O.BACK_TO_FRONT=-1]="BACK_TO_FRONT",O[O.NONE=0]="NONE",O[O.FRONT_TO_BACK=1]="FRONT_TO_BACK"}(O||(O={}));export{O as RenderOrder};
